<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        Auction List
      </slot>
    </CCardHeader>
    <CCardBody>
      <div>
        <CRow>
          <CCol lg="12">
            <CDataTable
            :items="this.$store.state.auctionList"
            :fields="[{key:'team_name', label:'', sorter:false}, {key:'last_name', label:'Player'}, {key:'original_cost', label:'Cost'}, {key:'total_points', label:'Total'}]"
            :tableFilter=true
            sorter
            hover
            striped
            bordered
            small
            fixed
          >
            <template #team_name="{item}">
              <td>
                <img width="24px" height="32px" :src="'img/team-kits/shirt_' + item.team_name_short + '-66.webp'" :alt="item.team_name" />
              </td>
            </template>
            <template #last_name="{item}">
              <TablePlayerItem :item="item" />
            </template>
            </CDataTable>
          </CCol>
        </CRow>
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import CTableWrapper from './base/Table.vue'
import TablePlayerItem from './base/TablePlayerItem.vue'

export default {
  name: 'AuctionList',
  components: { CTableWrapper, TablePlayerItem },
  created() {
    this.$store.dispatch("loadAuctionList");
  }
}
</script>
